import React, { useRef } from "react";
import { useModalA11y } from "../hooks/useModalA11y";

export default function HelpModal({ isOpen, onClose, onStartTour, onStartAdvancedTour, audience = "parent" }) {
  const modalRef = useRef(null);
  const closeRef = useRef(null);
  useModalA11y({
    isOpen,
    onClose,
    containerRef: modalRef,
    initialFocusRef: closeRef
  });

  if (!isOpen) return null;
  const isKid = audience === "kid";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="glass modal-content"
        onClick={e => e.stopPropagation()}
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-label="Help center"
      >
        <div className="header-flex">
          <h2 style={{ margin: 0 }}>📖 Help Center</h2>
          <button
            className="btn-nav"
            onClick={onClose}
            style={{ border: 'none', fontSize: '1.2rem' }}
            aria-label="Close help center"
            ref={closeRef}
          >
            ✕
          </button>
        </div>

        <div className="help-actions">
          {!isKid && onStartTour && (
            <button
              className="btn-nav success-btn"
              onClick={() => {
                onStartTour();
                onClose();
              }}
            >
              Run Quick Start Tour
            </button>
          )}
          {onStartAdvancedTour && (
            <button
              className="btn-nav"
              onClick={() => {
                onStartAdvancedTour();
                onClose();
              }}
            >
              Deep Dive Tour
            </button>
          )}
        </div>

        <div className="modal-scroll-body help-accordion">
          {isKid ? (
            <>
              <details open>
                <summary>✅ Kid Quick Start</summary>
                <ol>
                  <li>Open your chores on the Board.</li>
                  <li>Tap Done when you finish one.</li>
                  <li>Check points and rewards progress.</li>
                </ol>
              </details>
              <details>
                <summary>💬 Need Help?</summary>
                <p>Use the clarification button on a chore to ask for help from a parent.</p>
              </details>
              <details>
                <summary>🏆 Points</summary>
                <p>Points are added after a parent approves your completed chores.</p>
              </details>
              <details>
                <summary>📅 Calendar</summary>
                <p>Family events are shown on the board so you can see what is coming up.</p>
              </details>
            </>
          ) : (
            <>
              <details open>
                <summary>✅ Quick Start (3 steps)</summary>
                <ol>
                  <li>Add kids in Settings → Kids.</li>
                  <li>Create a few chores in Parent Hub.</li>
                  <li>Kids tap Done; parents approve or clarify.</li>
                </ol>
                <p>Most families are fully set up in under 5 minutes.</p>
              </details>
              <details>
                <summary>🧱 Parent Hub Layout</summary>
                <p>Click Edit Layout to drag and resize cards. The ghost preview shows exactly where a card will land.</p>
                <p>Use Guided Layout to apply the recommended order anytime.</p>
              </details>
              <details>
                <summary>🎯 Assigning Chores</summary>
                <p>Create tasks in Assign Chores and choose a kid, points, and schedule.</p>
                <p>Points are awarded after a parent approves.</p>
              </details>
              <details>
                <summary>💬 Approvals + Clarifications</summary>
                <p>Approvals are your daily review list. Clarifications keep questions and replies in one thread.</p>
                <p>Resolve a clarification when the task is updated or approved.</p>
              </details>
              <details>
                <summary>🏠 Home Setup (Tablets + Kid Devices)</summary>
                <ul>
                  <li>Place a shared tablet in a central spot.</li>
                  <li>Enable Big Tap Mode for touch‑friendly use.</li>
                  <li>Install the app on each kid’s device if they have one.</li>
                  <li>Use Compact Mode on dense screens.</li>
                </ul>
              </details>
              <details>
                <summary>⭐ Free vs Pro</summary>
                <p><strong>Free</strong> includes up to 2 kids and 8 active chores.</p>
                <p><strong>Pro</strong> adds family sharing, unlimited kids/tasks, billing tools, templates, and integrations.</p>
              </details>
              <details>
                <summary>🧾 Feedback</summary>
                <p>Open Feedback / Help from the top bar to send suggestions and read admin replies.</p>
              </details>
              <details>
                <summary>🔐 Default PINs</summary>
                <p>Default parent PIN: <strong>1234</strong>.</p>
                <p>If Younger Child PIN is enabled and not set yet, the default is also <strong>1234</strong>.</p>
              </details>
            </>
          )}
        </div>
        
        <button className="btn-nav success-btn" style={{ width: '100%', marginTop: '20px', padding: '12px' }} onClick={onClose}>
          I Understand!
        </button>
      </div>
    </div>
  );
}
